















































import Vue from 'vue'
import { FeedbackTemplateModel } from '@/models/FeedbackTemplateModel'

export default Vue.extend({
  name: 'TemplateList',
  components: {},
  props: {
    value: {
      default: '',
      type: String,
      required: false
    }
  },
  data: () => ({
    templates: [] as FeedbackTemplateModel[],
    expandedTemplates: [] as number[],
    selectedTemplates: [] as FeedbackTemplateModel[],
    checkedState: '',
    error: null as any,
    headers: [
      { text: 'Title', value: 'title' },
      { text: '', value: 'data-table-expand' }
    ]
  }),
  methods: {
    selectRow (checkedItem: any) {
      this.selectedTemplates.splice(0, this.selectedTemplates.length)
      if (checkedItem.value === true) {
        this.selectedTemplates.push(checkedItem)
      }
      console.log(`selectedTemplates: ${this.selectedTemplates.length}, checkedItem: true? ${checkedItem.value === true}`)
    },
    onChecked (event: any, templateId: string) {
      this.$emit('input', this.checkedState)
    },
    handleRowClick (value: any) {
      this.expandedTemplates.push(value)
    }
  },
  async mounted () {
    await this.$store
      .dispatch('getFeedbackTemplates', { category: '' })
      .then(async (fr: any) => {
        if (!fr) {
          this.error = new Error('Oops, the templates could not be retrieved.')
          return Promise.reject(this.error)
        }
        this.error = null
        this.templates = fr
        this.expandedTemplates = (fr as FeedbackTemplateModel[]).map((m: FeedbackTemplateModel, i: number) => i)
        this.$emit('apicallend')
        return Promise.resolve(this.templates)
      },
      (err: any) => {
        this.error = err
        this.$emit('apicallend')
      })
  }
})
